import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../../context/I18nContext';
import { APPS_DATA } from '../../data/apps';

export const Footer: React.FC = () => {
  const { t } = useI18n();

  return (
    <footer className="bg-slate-50 border-t border-slate-200 text-slate-600 text-sm mt-auto">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8 lg:gap-12">
          {/* Studio Brand Column */}
          <div className="col-span-2 lg:col-span-2 space-y-4">
            <Link to="/" className="inline-flex items-center gap-2.5 font-bold text-slate-900 text-lg tracking-tight">
              <span className="w-7 h-7 rounded-lg bg-primary-500 flex items-center justify-center text-white text-sm font-black shadow-xs">
                K
              </span>
              <span>Kapitalletter</span>
            </Link>
            <p className="text-slate-500 text-sm max-w-sm leading-relaxed">
              일상을 더 편리하게 만드는 모바일 경험을 개발합니다.
            </p>
          </div>

          {/* Apps Column */}
          <div>
            <h3 className="font-semibold text-slate-900 text-xs uppercase tracking-wider mb-4">
              {t.nav.apps}
            </h3>
            <ul className="space-y-2.5">
              {APPS_DATA.map((app) => (
                <li key={app.slug}>
                  <Link
                    to={`/apps/${app.slug}`}
                    className="text-slate-600 hover:text-slate-900 transition-colors"
                  >
                    {app.name}
                  </Link>
                </li>
              ))}
              <li className="pt-1">
                <Link to="/apps" className="text-primary-700 hover:text-primary-800 font-medium text-xs">
                  {t.nav.allApps} →
                </Link>
              </li>
            </ul>
          </div>

          {/* Support Column */}
          <div>
            <h3 className="font-semibold text-slate-900 text-xs uppercase tracking-wider mb-4">
              {t.nav.support}
            </h3>
            <ul className="space-y-2.5">
              <li>
                <Link to="/support" className="text-slate-600 hover:text-slate-900 transition-colors">
                  통합 고객지원 허브
                </Link>
              </li>
              {APPS_DATA.map((app) => (
                <li key={app.slug}>
                  <Link
                    to={`/support/${app.slug}`}
                    className="text-slate-600 hover:text-slate-900 transition-colors"
                  >
                    {app.name} 지원
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h3 className="font-semibold text-slate-900 text-xs uppercase tracking-wider mb-4">
              Company
            </h3>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-slate-600 hover:text-slate-900 transition-colors">
                  {t.nav.about}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-600 hover:text-slate-900 transition-colors">
                  {t.nav.contact}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Disclaimers & Copyright */}
        <div className="mt-12 pt-8 border-t border-slate-200 text-xs text-slate-400 space-y-3">
          <p className="leading-relaxed">
            Apple, the Apple logo, and iPhone are trademarks of Apple Inc., registered in the U.S. and other countries. App Store is a service mark of Apple Inc. Google Play and the Google Play logo are trademarks of Google LLC.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-2">
            <p>{t.common.copyright}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};
